<template>
  <PageWrapper
    :active-section="SECTION_MONETIZATION"
    :active-page="PAGE_MONETIZATION_OVERVIEW"
    :breadcrumbs="breadcrumbs"
    page-name="Overview"
    title="Overview"
    align="left"
    width="fixed"
  >
    <iText>
      This page shows a high-level overview of your revenue streams by category over the last 30 days and highlights how
      each component contributes to the overall financial picture, helping to identify key drivers and areas for
      potential improvement.
    </iText>
    <OverviewSankeyGraph />
    <iDataTable
      :fields="overviewFields"
      :items="overviewItems"
      :has-more="false"
      :is-loading="false"
      primary-key="type"
      hide-actions
    >
      <template #td="{data, value}">
        <iText :font-weight="data.type === 'Net Revenue' ? 'dark' : 'standard'">
          {{ value }}
        </iText>
      </template>
    </iDataTable>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import { SECTION_MONETIZATION, PAGE_MONETIZATION_OVERVIEW } from "@/constants/nav-constants";
import { overviewFields, overviewItems } from "@/constants/monetization-fake-data";
import OverviewSankeyGraph from "@/components/monetization/OverviewSankeyGraph.vue";

export default {
  name: "Overview",
  components: {
    OverviewSankeyGraph,
    PageWrapper,
  },
  data() {
    return {
      SECTION_MONETIZATION,
      PAGE_MONETIZATION_OVERVIEW,
      overviewFields,
      overviewItems,
    };
  },
  computed: {
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: `/monetization/org/${this.orgId}`, label: "Monetization" },
      ];
    },
  },
};
</script>
